export const initial = {
    submitting: false,
    type: null,
    lists: null,
};

export const update = (state, payload) => {
    return { ...state, ...payload };
};
